<template>
  <div class="m" style="background">
    <!-- <NavBar /> -->
    <GoBack :title="$t('mobile.PwCYouPlusProgramme')" />
    <div class="m-main">
      <van-swipe v-if="lang === 'zh'" class="pdf-swipe" :autoplay="5000" indicator-color="#d04a02" @change="onChange">
        <van-swipe-item v-for="(item,index) in 16" :key="index">
          <img width="100%" :src="objZH['imgZH' + (index + 1)]" @click="imgPreview(objZH,index)">
        </van-swipe-item>
      </van-swipe>
      <van-swipe v-else class="pdf-swipe" :autoplay="5000" indicator-color="#d04a02" @change="onChange">
        <van-swipe-item v-for="(item,index) in 16" :key="index">
          <img width="100%" :src="objEN['imgEN' + (index + 1)]" @click="imgPreview(objEN,index)">
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="bottom-btn">
      <van-button type="primary" :disabled="hasSubmit" @click="clickBtn">{{ hasSubmit? $t('mobile.consulted') : $t('mobile.consult') }}</van-button>
    </div>
  </div>
</template>
<script>
import { common } from './common/mixin.js'
import { setSurveyRedirectUrl, removeSurveyRedirectUrl } from '@/util/auth'
import GoBack from './GoBack'

// ZH
import imgZH1 from '@/assets/m/YouPlusZH-1.jpg'
import imgZH2 from '@/assets/m/YouPlusZH-2.jpg'
import imgZH3 from '@/assets/m/YouPlusZH-3.jpg'
import imgZH4 from '@/assets/m/YouPlusZH-4.jpg'
import imgZH5 from '@/assets/m/YouPlusZH-5.jpg'
import imgZH6 from '@/assets/m/YouPlusZH-6.jpg'
import imgZH7 from '@/assets/m/YouPlusZH-7.jpg'
import imgZH8 from '@/assets/m/YouPlusZH-8.jpg'
import imgZH9 from '@/assets/m/YouPlusZH-9.jpg'
import imgZH10 from '@/assets/m/YouPlusZH-10.jpg'
import imgZH11 from '@/assets/m/YouPlusZH-11.jpg'
import imgZH12 from '@/assets/m/YouPlusZH-12.jpg'
import imgZH13 from '@/assets/m/YouPlusZH-13.jpg'
import imgZH14 from '@/assets/m/YouPlusZH-14.jpg'
import imgZH15 from '@/assets/m/YouPlusZH-15.jpg'
import imgZH16 from '@/assets/m/YouPlusZH-16.jpg'
// EN
import imgEN1 from '@/assets/m/YouPlusEN-1.jpg'
import imgEN2 from '@/assets/m/YouPlusEN-2.jpg'
import imgEN3 from '@/assets/m/YouPlusEN-3.jpg'
import imgEN4 from '@/assets/m/YouPlusEN-4.jpg'
import imgEN5 from '@/assets/m/YouPlusEN-5.jpg'
import imgEN6 from '@/assets/m/YouPlusEN-6.jpg'
import imgEN7 from '@/assets/m/YouPlusEN-7.jpg'
import imgEN8 from '@/assets/m/YouPlusEN-8.jpg'
import imgEN9 from '@/assets/m/YouPlusEN-9.jpg'
import imgEN10 from '@/assets/m/YouPlusEN-10.jpg'
import imgEN11 from '@/assets/m/YouPlusEN-11.jpg'
import imgEN12 from '@/assets/m/YouPlusEN-12.jpg'
import imgEN13 from '@/assets/m/YouPlusEN-13.jpg'
import imgEN14 from '@/assets/m/YouPlusEN-14.jpg'
import imgEN15 from '@/assets/m/YouPlusEN-15.jpg'
import imgEN16 from '@/assets/m/YouPlusEN-16.jpg'
import { getLocal } from '@/util/local'

export default {
  name: 'YouPlusProgramme',
  components: {
    GoBack
  },
  mixins: [common],
  data() {
    return {
      current: 1,
      objZH: {
        imgZH1,
        imgZH2,
        imgZH3,
        imgZH4,
        imgZH5,
        imgZH6,
        imgZH7,
        imgZH8,
        imgZH9,
        imgZH10,
        imgZH11,
        imgZH12,
        imgZH13,
        imgZH14,
        imgZH15,
        imgZH16
      },
      objEN: {
        imgEN1,
        imgEN2,
        imgEN3,
        imgEN4,
        imgEN5,
        imgEN6,
        imgEN7,
        imgEN8,
        imgEN9,
        imgEN10,
        imgEN11,
        imgEN12,
        imgEN13,
        imgEN14,
        imgEN15,
        imgEN16
      }
    }
  },
  computed: {
    hasSubmit() {
      return Boolean(getLocal('Q1595918956534').length > 0)
    }
  },
  created() {
    removeSurveyRedirectUrl()
  },
  methods: {
    onChange(index) {
      this.current = index + 1
    },
    clickBtn() {
      setSurveyRedirectUrl(this.$route.fullPath)
      const url = '/survey-new?surveyKey=Q1595918956534'
      this.$router.push({ path: url })
    }
  }
}
</script>
<style>
</style>
